module.exports = __webpack_public_path__ + "img/img_sponsor.0227453a.webp";